export const ru = {
    add: 'Выбрать',
    cancel: 'Отменить',
    title: 'Креатив «{creativeName}»'
};
